export default {
  messages: {
    common: {
      save: 'Save',
      cancel: 'Cancel',
      confirm: 'Confirm',
      delete: 'Delete',
      edit: 'Edit',
      refresh: 'Refresh',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      search: 'Search',
      noData: 'No data',
      online: 'Online',
      offline: 'Offline',
      enabled: 'Enabled',
      disabled: 'Disabled',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
      operationFailed: 'Operation failed: {msg}',
      copySuccess: 'Copied to clipboard',
      justNow: 'Just now',
      minutesAgo: '{n} minutes ago',
      hoursAgo: '{n} hours ago',
      daysAgo: '{n} days ago',
      unknown: 'Unknown',
      timeFormatError: 'Invalid time format',
      user: 'User',
      joined: 'joined',
    },

    home: {
      greeting: {
        lateNight: 'Late night',
        morning: 'Good morning',
        noon: 'Good afternoon',
        afternoon: 'Good afternoon',
        evening: 'Good evening',
      },
      proMember: 'Pro Member',
      joinedDate: 'Joined {date}',
      manageServers: 'Manage Servers',
      stats: {
        totalServers: 'Total Servers',
        onlineServers: 'Online Servers',
        proServers: 'Pro Servers',
        connected: 'Connected',
        disconnected: 'Disconnected',
        realtimeChannel: 'Realtime',
      },
      validUntil: 'Valid until {date}',
      manageSubscription: 'Manage',
      upgradeToPro: 'Upgrade to Pro',
      upgradeDesc: 'Unlock remote management, live monitoring, and more',
      learnMore: 'Learn More',
      myServers: 'My Servers',
      viewAll: 'View All',
      unnamedServer: 'Unnamed Server',
      notConfigured: 'Not configured',
      noServers: 'No servers yet',
      addFirstServer: 'Add your first Minecraft server',
      addServer: 'Add Server',
      quickLinks: 'Quick Links',
      quickLink: {
        userDocs: 'User Docs',
        userDocsDesc: 'Learn how to use UltiKits',
        devDocs: 'Dev Docs',
        devDocsDesc: 'UltiTools API reference',
        github: 'GitHub',
        githubDesc: 'View open source projects',
        status: 'Status',
        statusDesc: 'UltiKits service monitor',
      },
      ecosystem: 'UltiKits Ecosystem',
      noModules: 'No module data',
    },

    nav: {
      home: 'Home',
      servers: 'Servers',
      member: 'Member',
      modules: 'Modules',
      developer: 'Developer',
      admin: 'Admin',
      profile: 'My Profile',
      logout: 'Logout',
      logoutMsg: 'You have been logged out',
    },

    server: {
      tabs: {
        dashboard: 'Dashboard',
        players: 'Players',
        worlds: 'Worlds',
        plugins: 'Plugins',
        logs: 'Logs',
        settings: 'Settings',
        backups: 'Backups',
        errors: 'Errors',
      },

      dashboard: {
        title: 'Server Dashboard',
        refresh: 'Refresh',
        onlinePlayers: 'Online Players',
        memory: 'Memory',
        serverInfo: 'Server Info',
        version: 'Version',
        uptime: 'Uptime',
        worldCount: 'Worlds',
        performanceMetrics: 'Performance Metrics',
        serverControl: 'Server Control',
        restart: 'Restart',
        shutdown: 'Shutdown',
        countdownRestart: 'Restarting in {n}s',
        countdownShutdown: 'Shutting down in {n}s',
        restartingMsg: 'Server is restarting...',
        shuttingDownMsg: 'Server is shutting down...',
        tpsGood: 'Good',
        tpsFair: 'Fair',
        tpsLow: 'Low',
        cpuNormal: 'Normal',
        cpuHigh: 'High',
        cpuOverload: 'Overloaded',
        memNormal: 'Normal',
        memHigh: 'High',
        memVeryHigh: 'Very High',
        memoryUsage: 'Memory Usage',
        notActivated: 'Server not activated. Enable Pro to use management features.',
        serverOffline: 'Server Offline',
        offlineDetail: 'Showing last known data. Commands will execute when server comes online.',
        connected: 'Connected',
        disconnected: 'Disconnected',
        serverWentOffline: 'Server went offline',
        serverWentOnline: 'Server came online',
        memoryHigh: 'High memory usage',
      },

      logs: {
        title: 'Server Logs',
        filter: 'Log Filter',
        realtime: 'Real-time Logs',
        realtimeEnabled: 'Enabled',
        realtimeStopped: 'Stopped',
        copyFeedback: 'Copied',
        copyCount: 'Copy ({n})',
        noLogs: 'No logs available',
      },

      terminal: {
        title: 'Terminal',
        stopLogStream: 'Stop log stream',
        startLogStream: 'Start log stream',
        exitFullscreen: 'Exit fullscreen',
        fullscreen: 'Fullscreen',
        inputPlaceholder: 'Enter command...',
        waitingForInput: 'Waiting for command input...',
      },

      settings: {
        navigation: 'Settings Navigation',
        fileManager: 'File Management',
        pluginConfig: 'Plugin Configuration',
        serverConfig: 'Server Configuration',
        structuredConfig: 'Module configuration editor',
        configSnapshotHint: 'Values come from the server’s last connection upload. Refresh reloads that snapshot, not the current server files. Only changed settings are sent when saving.',
      },

      metrics: {
        title: 'Performance History',
        threshold: 'Threshold',
        memoryLabel: 'Memory',
        playersLabel: 'Players',
        loadingData: 'Loading performance data...',
        loadFailed: 'Failed to load performance data',
        noDataYet: 'No data yet. Server needs to be online for at least 1 minute.',
        avgTps: 'Avg TPS',
        peakMemory: 'Peak Memory',
        peakPlayers: 'Peak Players',
        avgCpu: 'Avg CPU',
      },

      players: {
        title: 'Player Management',
        onlineCount: 'Online Players ({n})',
        search: 'Search...',
        sortBy: 'Sort: {label}',
        sortName: 'Name',
        sortHealth: 'Health',
        sortWorld: 'World',
        teleport: 'Teleport',
        kick: 'Kick',
        noPlayers: 'No online players',
        notFound: 'No results for "{query}"',
        playerJoined: '{name} joined the game',
        playerLeft: '{name} left the game',
        activity: 'Player Activity',
        noActivity: 'No activity',
        teleportedTo: 'Teleported to {name}',
        teleportFailed: 'Teleport failed: {msg}',
        kicked: 'Kicked {name}',
        kickFailed: 'Kick failed: {msg}',
        kickDialogTitle: 'Kick Player',
        kickReason: 'Kick reason (optional)',
        gamemodeSurvival: 'Survival',
        gamemodeCreative: 'Creative',
        gamemodeAdventure: 'Adventure',
        gamemodeSpectator: 'Spectator',
        gamemodeSet: 'Set {name} to {mode}',
        gamemodeSetFailed: 'Failed to set gamemode: {msg}',
      },

      worlds: {
        title: 'World Management',
        loadedWorlds: 'Loaded Worlds',
        playerChunkInfo: '{players} players · {chunks} chunks',
        noWorldData: 'No world data',
        worldBackups: 'World Backups',
        noBackups: 'No backups',
        createBackup: 'Create Backup',
        difficulty: 'Difficulty',
        onlinePlayers: 'Online Players',
        loadedChunks: 'Loaded Chunks',
        pvp: 'PVP',
        pvpOn: 'On',
        pvpOff: 'Off',
        spawnLocation: 'Spawn Location',
        diffPeaceful: 'Peaceful',
        diffEasy: 'Easy',
        diffNormal: 'Normal',
        diffHard: 'Hard',
      },

      plugins: {
        title: 'Plugin Management',
        sidebar: 'Plugin List',
        noPlugins: 'No plugins',
        search: 'Search plugins...',
        noMatch: 'No matching plugins',
        noPluginData: 'No plugin data',
        reload: 'Reload',
        reloaded: '{name} reloaded',
        reloadFailed: 'Reload failed: {msg}',
      },

      backups: {
        title: 'Backup Management',
        overview: 'Backup Overview',
        totalBackups: 'Total Backups',
        latestBackup: 'Latest Backup',
        none: 'None',
        quickActions: 'Quick Actions',
        creating: 'Creating...',
        createBackup: 'Create Backup',
        refreshing: 'Loading...',
        refreshList: 'Refresh List',
        noBackups: 'No backups',
        startHint: 'Click "Create Backup" to start',
        details: 'Backup Details',
        id: 'ID',
        time: 'Time',
        status: 'Status',
        restore: 'Restore',
        confirmRestore: 'Confirm Restore',
        confirmRestoreMsg: 'Are you sure you want to restore this backup? Current server data will be overwritten.',
        confirmDelete: 'Confirm Delete',
        confirmDeleteMsg: 'Are you sure you want to delete this backup? This action cannot be undone.',
        statusCompleted: 'Completed',
        statusInProgress: 'In Progress',
        statusPending: 'Pending',
        statusFailed: 'Failed',
        fetchFailed: 'Failed to fetch backup list: {msg}',
        createSent: 'Backup creation request sent',
        createFailed: 'Backup creation failed: {msg}',
        restoreSent: 'Backup restore request sent',
        restoreFailed: 'Backup restore failed: {msg}',
        deleted: 'Backup deleted',
        deleteFailed: 'Delete failed: {msg}',
      },

      files: {
        loadFailed: 'Failed to load directory: {msg}',
        unsavedChanges: 'You have unsaved changes. Discard?',
        readFailed: 'Failed to read file: {msg}',
        saved: 'File saved',
        saveFailed: 'Save failed: {msg}',
        deleteConfirm: 'Are you sure you want to delete {name}?',
        deleteConfirmDir: ' (including all subdirectories)',
        deleted: 'Deleted {name}',
        deleteFailed: 'Delete failed: {msg}',
        browser: 'File Browser',
        emptyDir: 'Directory is empty',
        selectFile: 'Select a file to start editing',
      },

      pluginSettings: {
        selectPlugin: 'Select Plugin',
        noPluginData: 'No plugin data',
        selectFile: 'Select a file to start editing',
        selectPluginHint: 'Select a plugin to view its configuration',
        loadFailed: 'Failed to load plugin files: {msg}',
        unsavedChanges: 'You have unsaved changes. Discard?',
        readFailed: 'Failed to read file: {msg}',
        saved: 'File saved',
        saveFailed: 'Save failed: {msg}',
      },

      settingsPanel: {
        title: 'Server Configuration',
        restartRequired: 'Restart required to apply changes',
        saveConfig: 'Save Configuration',
        general: 'General Settings',
        motd: 'Server Description (MOTD)',
        maxPlayers: 'Max Players',
        viewDistance: 'View Distance',
        simulationDistance: 'Simulation Distance',
        spawnProtection: 'Spawn Protection Radius (0 = off)',
        gameRules: 'Game Rules',
        difficulty: 'Difficulty',
        diffPeaceful: 'Peaceful',
        diffEasy: 'Easy',
        diffNormal: 'Normal',
        diffHard: 'Hard',
        defaultGamemode: 'Default Gamemode',
        gamemodeSurvival: 'Survival',
        gamemodeCreative: 'Creative',
        gamemodeAdventure: 'Adventure',
        gamemodeSpectator: 'Spectator',
        toggleSettings: 'Toggle Settings',
        pvp: 'PVP',
        allowNether: 'Allow Nether',
        allowFlight: 'Allow Flight',
        spawnAnimals: 'Spawn Animals',
        spawnMonsters: 'Spawn Monsters',
        spawnNpcs: 'Spawn NPCs',
        enableCommandBlock: 'Command Blocks',
        loadFailed: 'Failed to load config: {msg}',
        configSaved: 'Server confirmed configuration saved',
        configSaveFailed: 'Configuration submission failed: {msg}',
        pending: 'Submitting configuration; waiting for the server to confirm…',
        unconfirmed: 'The server has not confirmed whether the configuration took effect. Check the server before retrying.',
        refused: 'The server refused the configuration update',
        confirmFailed: 'Unable to confirm whether the configuration took effect: {msg}',
        unavailable: 'The server’s actual configuration is unavailable. Saving is disabled; edit server.properties directly on the server.',
      },
    },

    notifications: {
      title: 'Notifications',
      clearAll: 'Clear all',
      noNotifications: 'No notifications',
    },

    // --- Error Reporting ---
    errors: {
      title: 'Error Reports',
      frameworkTitle: 'Framework Errors',
      filterTitle: 'Filters',
      filterAll: 'All',
      filterModule: 'Module Filter',
      filterTrigger: 'Trigger Type',
      unresolved: 'Unresolved',
      resolved: 'Resolved',
      resolve: 'Mark Resolved',
      unresolve: 'Mark Unresolved',
      resolvedSuccess: 'Marked as resolved',
      unresolvedSuccess: 'Marked as unresolved',
      expand: 'Expand',
      collapse: 'Collapse',
      stats: 'Statistics',
      totalErrors: 'Total Errors',
      unresolvedErrors: 'Unresolved Errors',
      noErrors: 'No errors recorded',
      stackTrace: 'Stack Trace',
      serverContext: 'Server Context',
      memoryPercent: 'Memory Usage',
      playerCount: 'Online Players',
      triggerDetail: 'Trigger Detail',
      details: 'Details',
      firstSeen: 'First Seen',
      lastSeen: 'Last Seen',
      occurrences: 'Occurrences',
      fingerprint: 'Fingerprint',
      triggerCommand: 'Command',
      triggerEvent: 'Event',
      triggerScheduled: 'Scheduled',
      triggerAop: 'AOP',
      triggerUncaught: 'Uncaught',
    },

    // --- Developer Error Reports ---
    developerErrors: {
      title: 'Module Error Reports',
      subtitle: 'Aggregated error reports from servers using your modules',
      totalErrors: 'Total Errors',
      unresolvedErrors: 'Unresolved Errors',
      topModule: 'Most Affected Module',
      filterModule: 'Module',
      filterStatus: 'Status',
      total: '{n} errors total',
    },

    serverList: {
      title: 'Servers',
      summary: '{online} online · {total} servers',
      addServer: 'Add Server',
      searchPlaceholder: 'Search servers...',
      filter: 'Filter...',
      uuidNotSet: 'UUID not set',
      needUuid: 'Set UUID',
      noMatch: 'No matching servers found',
      adjustSearch: 'Try adjusting your search criteria or clearing filters',
      addFirstServer: 'Add your first Minecraft server to get started',
      autoRegisterNotice: 'With UltiTools 6, servers are automatically registered to UltiKits Cloud.',
      serverName: 'Server Name*',
      serverDomain: 'Server Domain*',
      domainExample: 'e.g. minecraft.example.com',
      serverUuid: 'Server UUID*',
      uuidHint: 'Found in /plugin/UltiCore folder',
      serverIp: 'Server IP or Domain',
      optional: 'Optional',
      activateNow: 'Activate server immediately',
      setUuidTitle: 'Set Server UUID',
      setUuidDesc: 'Set UUID for {name}. Found in the server\'s /plugin/UltiCore folder.',
      uuidFormat: 'Format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
      setUuid: 'Set UUID',
      nameRequired: 'Server name is required',
      domainRequired: 'Server domain is required',
      uuidRequired: 'Server UUID is required',
      uuidEmpty: 'UUID cannot be empty',
      uuidLength: 'UUID must be 36 characters',
      uuidFormat2: 'Invalid UUID format',
      activated: 'Activated',
      ssl: 'SSL',
      unactivated: 'Unactivated',
      noSsl: 'No SSL',
      fetchFailed: 'Failed to fetch server list: {msg}',
      addSuccess: 'Server added successfully',
      addFailed: 'Failed to add server: {msg}',
      uuidUpdated: 'UUID updated for server "{name}"',
      uuidUpdateFailed: 'Failed to update UUID: {msg}',
      noServers: 'No servers yet',
    },

    member: {
      congratulations: 'Congratulations',
      thankYou: 'Thank you for purchasing UltiKits membership',
      viewStatus: 'View my membership status',
      legacyNotice: 'Users who purchased UltiTools paid version before Feb 14, 2021 can redeem Pro membership using their activation code in the "Redeem" tab below',
      wechatNotice: 'WeChat Pay unavailable',
      wechatNoticeDetail: 'Due to force majeure, WeChat Pay is currently unavailable. To purchase UltiKits Pro membership, please use Alipay or contact support.',
      title: 'UltiKits Membership',
      subtitle: 'Upgrade to Pro for advanced features',
      proMember: 'Pro Member',
      freeMember: 'Free Member',
      validUntil: 'Valid until {date}',
      upgradeHint: 'Upgrade to unlock remote management, live monitoring, and more',
      activatableServers: 'Activatable Servers',
      tabPurchase: 'Purchase',
      tabRedeem: 'Redeem',
      tabUpgrade: 'Upgrade',
      tabBilling: 'Billing',
    },

    purchase: {
      loadingPrices: 'Loading prices...',
      priceUnavailable: 'Unable to get prices',
      checkNetwork: 'Please check your network and try again',
      reload: 'Reload',
      freeTrialTitle: 'Free 7-day Pro Trial',
      freeTrialDesc: 'Available to all users with a verified email',
      claimTrial: 'Claim Trial',
      trialCodeValid: 'Trial code is valid for 7 days',
      trialCodeOnce: 'Shown only once, please save it',
      trialCodeBound: 'Bound to this account, not usable by others',
      selectPlan: 'Select Plan',
      paymentMethods: 'This site supports bank card, Alipay, and WeChat Pay. Contact us for other payment methods.',
      noRefund: 'Purchases are non-refundable in principle. Please confirm your needs before purchasing.',
      autoActivate: 'Pro membership activates automatically after payment. If already Pro, duration will be extended.',
      selected: 'Selected',
      total: 'Total',
      submitOrder: 'Submit Order',
      getCodeFailed: 'Failed to get redemption code: {msg}',
      getPriceFailed: 'Failed to get prices: {msg}',
      invalidClientSecret: 'No valid clientSecret received, please try again',
      invalidClientSecretFormat: 'Invalid clientSecret format, please contact support',
      orderCreated: 'Order created successfully',
      orderCreateFailed: 'Order creation failed: {msg}',
      stripeNotInit: 'Stripe not properly initialized, please refresh the page',
      monthlyPlan: 'UltiKits Pro Monthly',
      quarterlyPlan: 'UltiKits Pro Quarterly',
      semiAnnualPlan: 'UltiKits Pro Semi-Annual',
      annualPlan: 'UltiKits Pro Annual',
      daysPlan: 'UltiKits Pro {n}-Day',
      verifyEmailFirst: 'Please verify your email first',
      alreadyPro: 'You are already a Pro member',
      clickToGetCode: 'Click to get redemption code',
      stripeInitFailed: 'Payment system initialization failed, please refresh',
      stripeLoadFailed: 'Payment system failed to load: {msg}',
      paymentValidationFailed: 'Payment validation failed',
      paymentUnknownError: 'An unknown error occurred during payment, please retry',
      paymentConfirmFailed: 'Payment confirmation failed: {msg}',
      orderCancelled: 'Order cancelled successfully',
      orderCancelFailed: 'Failed to cancel order: {msg}',
      orderNotFound: 'Order not found, please create a new order',
      refreshStatus: 'Refresh status',
      statusRefreshFailed: 'Could not refresh the order status, please try again',
      statusVerified: 'Payment verified. Pro access activates once the membership refresh confirms your entitlement.',
      statusPending: 'Payment is still pending. Complete the payment, or refresh this status later.',
      statusUnverified: 'We received your payment evidence but have not verified it yet. Pro access is not active.',
      statusFailed: 'This payment was closed or failed. Create a new order to try again.',
    },

    redeem: {
      guide: 'Redeem Guide',
      guideDesc: 'Use CD Key to activate paid licenses. Use redemption codes for events or free trials.',
      cdkTitle: 'Activate with CD Key',
      cdkPlaceholder: 'XXXX-XXXX-XXXX-XXXX',
      redeemTitle: 'Redeem with Code',
      redeemPlaceholder: 'Enter redemption code',
      activateSuccess: 'Activation successful',
      activateFailed: 'Activation failed: {msg}',
      redeemSuccess: 'Redemption successful',
      redeemFailed: 'Redemption failed: {msg}',
    },

    upgrade: {
      currentServers: 'Current activatable servers',
      upgradeHint: 'Upgrade for more server quota',
      inDevelopment: 'Upgrade feature in development',
      comingSoon: 'This feature is under construction, stay tuned',
    },

    profile: {
      accountInfo: 'Account Information',
      username: 'Username',
      email: 'Email',
      emailVerified: 'Verified',
      password: 'Password',
      passwordSet: 'Password protection is set',
      preferences: 'Preferences',
      themeSettings: 'Theme',
      themeLight: 'Light',
      themeDark: 'Dark',
      themeAuto: 'System',
      languageSettings: 'Language',
      editEmail: 'Edit Email',
      editPassword: 'Change Password',
      newEmail: 'New email address',
      verificationCode: 'Verification code',
      codeSentTo: 'Verification code sent to {email}',
      sendCode: 'Send Code',
      confirmEdit: 'Confirm',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm new password',
      stepEnterEmail: 'Enter new email',
      stepVerifyEmail: 'Verify email',
      codeSentSuccess: 'Verification code sent to your email',
      sendFailed: 'Failed to send',
      emailChanged: 'Email changed successfully',
      verifyFailed: 'Verification failed',
      passwordChanged: 'Password changed successfully',
      changeFailed: 'Change failed',
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email format',
      passwordRequired: 'Password is required',
      passwordMinLength: 'Password must be at least 6 characters',
      confirmPasswordRequired: 'Confirm password is required',
      passwordMismatch: 'Passwords do not match',
      codeRequired: 'Verification code is required',
      codeLength: 'Verification code must be 6 digits',
      user: 'User',
      joinedAt: 'Joined {date}',
      unknownDate: 'Unknown',
      invalidDate: 'Invalid date format',
      logout: 'Log Out',
    },

    linkedIdentities: {
      title: 'Linked game identities',
      loading: 'Loading linked identities…',
      empty: 'No Minecraft player is linked to this account. Run /panel in game to link one.',
      unavailable: 'Linked game identities are not available yet.',
      loadFailed: 'Could not load linked identities: {message}',
      retry: 'Retry',
      server: 'Server',
      linkedAt: 'Linked {date}',
      ownerBadge: 'Server owner',
      unlink: 'Unlink',
      moveHint: 'To link a Minecraft player to a different account, unlink it here, log in to the other account, and run /panel again in game.',
      dialog: {
        title: 'Unlink {name}?',
        consequenceOwner: 'You own {server}. Unlinking removes the Minecraft player {name} from this account on that server. You keep ownership of {server} and your panel access to it.',
        consequencePlayer: 'Unlinking removes the Minecraft player {name} from this account on {server}. You also lose panel access to {server}.',
        cancel: 'Cancel',
        confirm: 'Unlink',
      },
      result: {
        accessRemoved: '{name} was unlinked. Your panel access to {server} was removed.',
        ownershipKept: '{name} was unlinked. You still own {server}.',
        alreadyUnlinked: '{name} is no longer linked to this account on {server}.',
      },
      unlinkFailed: 'Unlink failed: {message}',
      unknownError: 'Unknown error',
    },

    emailValidation: {
      hint: 'Verify your email to unlock more features',
      start: 'Start Verification',
      title: 'Email Verification',
      codeSentTo: 'Verification code sent to {email}',
      enterCode: 'Enter the 6-digit code you received',
      resend: 'Resend',
      sendFailed: 'Failed to send verification code: {msg}',
      verifySuccess: 'Verification successful',
      verifyFailed: 'Verification failed: {msg}',
    },

    creatorInsights: {
      totalModules: 'Total modules', cumulativeDownloads: 'Cumulative downloads', totalLikes: 'Total likes', totalComments: 'Total comments',
      loading: 'Loading creator insights…',
      error: { title: 'Unable to load creator insights' }, retry: 'Retry',
    },

    creatorModuleInsights: {
      title: 'Creator Insights', description: 'Cumulative metrics and recent community feedback for this module',
      metrics: { downloads: 'Cumulative downloads', likes: 'Likes', comments: 'Comments', versionCount: 'Versions' },
      activity: { title: 'Recent feedback and activity' },
      filter: { label: 'Filter activity', all: 'All', comment: 'Comments', like: 'Likes', versionPublished: 'Version published' },
      sort: { label: 'Sort activity', occurredAt: 'Occurred at', type: 'Type', ascending: 'Ascending', descending: 'Descending', toggleDirection: 'Toggle sort direction' },
      table: { type: 'Type', details: 'Details', occurredAt: 'Occurred at', sortBy: 'Sort by {column}' },
      loading: 'Loading creator insights…',
      empty: { title: 'No recent activity yet', description: 'Comments, likes, and published versions for this module will appear here.' },
      noMatch: { title: 'No matching activity', description: 'Try another activity type or clear the filter.', clearFilter: 'Clear activity filter' },
      error: { title: 'Could not load creator insights', description: 'Check your connection and try again.', retry: 'Retry creator insights' },
      a11y: { insightsRegion: 'Creator Insights', activityRegion: 'Recent feedback and activity', filter: 'Filter activity', sortField: 'Sort activity field', sortDirection: 'Toggle sort direction', sortColumn: 'Sort by {column}', retry: 'Retry creator insights', metric: '{metric} metric' },
    },

    moduleDetail: {
      a11y: {
        backToModules: 'Back to my modules',
        editModule: 'Edit {name}',
        deleteModule: 'Delete {name}',
      },
      actions: { edit: 'Edit', delete: 'Delete', publishVersion: 'Publish new version' },
      info: {
        shortDescription: 'Short description',
        description: 'Description',
        category: 'Category',
        uncategorized: 'Uncategorized',
        apiVersions: 'Compatible API versions',
        tags: 'Tags',
        createdAt: 'Created',
        updatedAt: 'Last updated',
      },
      versions: {
        title: 'Version history',
        latest: 'Latest',
        pendingUpload: 'Pending upload',
        empty: 'No versions published yet',
      },
      deleteDialog: {
        title: 'Delete module?',
        description: 'Delete {name}? This permanently removes every version and uploaded file.',
        cancel: 'Cancel',
        confirm: 'Delete module',
      },
      toast: {
        notFound: 'Module not found',
        loadFailed: 'Could not load module details',
        deleted: 'Module deleted',
        deleteFailed: 'Could not delete module: {message}',
        unknownError: 'Unknown error',
      },
    },

    developer: {
      title: 'Developer Center',
      becomeDev: 'Become a UltiKits Developer',
      becomeDevDesc: 'Register a developer account to publish modules to the UltiKits marketplace',
      register: 'Register Developer',
      devName: 'Developer Name',
      devNamePlaceholder: 'Your developer domain identifier',
      devNameHint: 'Cannot be changed after creation, will be used as your module storage path',
      submitRegister: 'Submit',
      nameRequired: 'Developer name is required',
      registerSuccess: 'Developer registration successful',
      registerFailed: 'Developer registration failed: ',
      loadFailed: 'Failed to load',
      loadFailedDesc: 'Failed to load developer info, please retry',
      reload: 'Reload',
      manageModules: 'Manage Modules',
      publishedModules: 'Published Modules',
      storageQuota: 'Storage Quota',
      latestUpdate: 'Latest Update',
      noActivity: 'None',
      accessToken: 'Access Token',
      tokenCopied: 'Access token copied to clipboard',
      myModules: 'My Modules',
      manageAll: 'Manage All',
      noDescription: 'No description',
      notPublished: 'Not published',
      noModules: 'No modules created yet',
      noModulesDesc: 'Click the button to create your first module',
      createModule: 'Create Module',
      resources: 'Developer Resources',
      quickLink: {
        devDocs: 'Dev Docs',
        devDocsDesc: 'UltiTools API development guide',
        userDocs: 'User Docs',
        userDocsDesc: 'UltiKits documentation',
        github: 'GitHub',
        githubDesc: 'View open source projects',
        marketplace: 'Marketplace',
        marketplaceDesc: 'Browse all modules',
      },
      date: {
        today: 'Today',
        yesterday: 'Yesterday',
        daysAgo: '{n} days ago',
        monthsAgo: '{n} months ago',
      },
    },

    modules: {
      title: 'Module Marketplace',
      subtitle: 'Discover and install modules to extend your server',
      totalCount: '{n} modules',
      searchPlaceholder: 'Search module name, description, or ID...',
      noDescription: 'No description',
      noMatch: 'No matching modules found',
      noModules: 'No modules available',
      tryOtherKeywords: 'Try other keywords or clear search',
      checkBackLater: 'Check back later',
      loadFailed: 'Unable to load modules',
      loadFailedHint: 'The marketplace could not be reached. Check your connection and try again.',
      retry: 'Retry',
      clearSearch: 'Clear Search',
      prevPage: 'Previous',
      nextPage: 'Next',
      categoryAll: 'All',
      sortNewest: 'Newest',
      sortByName: 'By Name',
      category: {
        'utilities': 'Utilities',
        'economy': 'Economy',
        'world-management': 'World Management',
        'social-chat': 'Social & Chat',
        'permissions-security': 'Permissions & Security',
        'gameplay': 'Gameplay',
      },
      date: {
        today: 'Today',
        yesterday: 'Yesterday',
        daysAgo: '{n} days ago',
        monthsAgo: '{n} months ago',
      },
    },

    admin: {
      title: 'Admin Dashboard',
      subtitle: 'Platform overview and management',
      tabs: {
        dashboard: 'Overview',
        users: 'User Management',
        servers: 'Server Management',
        redeem: 'Redeem Codes',
      },
      period: { '24h': '24 Hours', '7d': '7 Days', '30d': '30 Days', '90d': '90 Days' },
      stats: {
        totalRevenue: 'Total Revenue',
        paymentMethods: '{n} payment methods',
        onlineServers: 'Online Servers',
        registeredTotal: '{n} registered total',
        totalInstalls: 'Total Installs',
        thisMonth: 'This month +{n}',
        onlinePlayers: 'Online Players',
        acrossServers: 'Across {n} servers',
        totalUsers: 'Total Users',
        proMembers: '{n} Pro members',
        apiRequests: 'API Requests Today',
      },
      charts: {
        revenueTrend: 'Revenue Trend',
        revenueYAxis: 'Revenue (\u00A5)',
        topServers: 'Top Servers by API Requests',
        requestCount: 'Requests',
        serverPlayerActivity: 'Server & Player Activity',
        players: 'Players',
        servers: 'Servers',
        userGrowth: 'User Growth',
        newUsers: 'New Users',
        proConversion: 'Pro Conversion',
        downloads: '{n} downloads ({p}%)',
      },
      health: {
        title: 'Server Health',
        playersOnline: '{n} players online',
        server: 'Server',
        tps: 'TPS',
        memory: 'Memory',
        cpu: 'CPU',
        players: 'Players',
        noMetrics: 'No server metrics reported',
      },
      moduleSection: {
        title: 'Module Marketplace',
        totalDownloads: '{n} total downloads',
        topModules: 'Top Modules',
      },
      users: {
        searchPlaceholder: 'Search username or email...',
        id: 'ID',
        username: 'Username',
        email: 'Email',
        role: 'Role',
        proStatus: 'Pro Status',
        joinDate: 'Join Date',
        actions: 'Actions',
        noData: 'No user data',
        adjustPro: 'Adjust Pro',
        changeRole: 'Change Role',
        free: 'Free',
        expired: 'Expired',
        proRemaining: 'Pro ({n} days left)',
      },
      proDialog: {
        title: 'Adjust Pro Duration',
        user: 'User',
        currentStatus: 'Current status',
        days: 'days',
        daysLabel: 'Days (positive to add, negative to subtract)',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      roleDialog: {
        title: 'Change User Role',
        user: 'User',
        adminWarning: 'This will grant the user full administrator privileges.',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      servers: {
        searchPlaceholder: 'Search server name or IP...',
        id: 'ID',
        name: 'Name',
        owner: 'Owner',
        ip: 'IP',
        status: 'Status',
        uuid: 'UUID',
        active: 'Active',
        inactive: 'Inactive',
        noData: 'No server data',
      },
      redeem: {
        createCode: 'Create Code',
        code: 'Code',
        targetUser: 'Target User',
        days: 'Days',
        status: 'Status',
        createdAt: 'Created',
        expiresAt: 'Expires',
        actions: 'Actions',
        daysSuffix: '{n} days',
        clickToCopy: 'Click to copy',
        neverExpires: 'Never expires',
        revoke: 'Revoke',
        noData: 'No redeem code data',
        used: 'Used',
        expired: 'Expired',
        unused: 'Unused',
        filterAll: 'All',
        filterUnused: 'Unused',
        filterUsed: 'Used',
        filterExpired: 'Expired',
      },
      createDialog: {
        title: 'Create Redeem Code',
        success: 'Redeem code created!',
        targetUsername: 'Target Username',
        proDays: 'Pro Days',
        codeExpiry: 'Code Expiry (days, 0 = never)',
        cancel: 'Cancel',
        create: 'Create',
        close: 'Close',
      },
    },
    module: {
      marketplace: 'Module Marketplace',
      backToMarketplace: 'Back to Marketplace',
      notFound: 'Module not found',
      notFoundDesc: 'No module found with identifier "{id}"',
      loadFailed: 'Unable to load this module',
      loadFailedHint: 'The request failed. The module may still exist — try again.',
      retry: 'Retry',
      tabs: {
        description: 'Description',
        versions: 'Versions',
        comments: 'Comments',
      },
      description: {
        empty: 'No description available',
      },
      versions: {
        title: 'Version History',
        latest: 'Latest',
        empty: 'No versions available',
        loadFailed: 'Version history could not be loaded',
        noChangelog: 'No changelog available',
      },
      comments: {
        title: 'Community Comments',
        count: '{n} comments',
        placeholder: 'Write a comment...',
        charCount: '{n}/500',
        submit: 'Submit',
        loginHint: 'Log in to leave a comment',
        empty: 'No comments yet. Be the first!',
        loadFailed: 'Comments could not be loaded',
        loadMore: 'Load more',
      },
      sidebar: {
        install: 'Install',
        download: 'Download',
        metadata: 'Info',
        version: 'Version',
        published: 'Published',
        updated: 'Updated',
        apiCompat: 'API Compat',
        downloads: 'Downloads',
        likes: 'Likes',
        publisher: 'Publisher',
        category: 'Category',
        tags: 'Tags',
        noTags: 'No tags',
      },
    },
  },

  vuetify: {
    app: {
      auth: {
        welcome: 'Welcome back',
        username: 'Username',
        password: 'Password',
        register: 'Register account',
        forget: 'Forgot password',
        email: 'Email',
        pwdRepeat: 'Repeat password',
        backLogin: 'Back to login',
        findAccount: 'Retrieve account',
        account: 'Account',
        usernameOrEmail: 'Username or email',
        plzInputAccount: 'Please enter the account to retrieve',
        verify: 'Verify',
        codeVerify: 'Identity verification',
        codeSendTo: 'Verification code has been sent to',
        codeSent: 'Verification code has been sent, please check',
        codeSendFail: 'Failed to send verification code:',
        reSend: 'Resend',
        codeVerified: 'Identity verified successfully',
        verifyFailure: 'Verification failed:',
        resetPwd: 'Reset password',
        newPwd: 'New password',
        newPwdRepeat: 'Repeat new password',
        verifyExpire: 'Identity verification is valid until',
        resetHint: 'Please complete the password reset operation before this time',
        resetSuccess: 'Password reset successful, please login with the new password',
        resetFailure: 'Password reset failed: ',
        requiredField: 'This field is required',
        pwdRequireMoreThan: 'Password must be more than %n characters',
        pwdRequireOnlyAscii: 'Password can only contain letters, numbers, and underscores',
        pwdNotMatch: 'The passwords do not match',
        subTitle: 'Spigot server plugin management platform',
        profileFailure: 'Login failed: Unable to retrieve user information, please try again later',
        loginSuccess: 'Login successful: Welcome back,',
        loginFailure: 'Login failed:',
        badCredential: 'Login failed: Incorrect username or password',
        accountNotExistOrPasswordError: 'Account does not exist or incorrect password',
        usernameRequireMoreThan: 'Username must be more than {0} characters',
        usernameRequireLessThan: 'Username must be less than {0} characters',
        usernameRequireOnlyAscii: 'Username can only contain letters, numbers, and underscores',
        requireAvailableEmail: 'Please enter a valid email',
        registerSuccess: 'Registration successful, please login',
        registerFailure: 'Registration failed:',
        registerNetworkError: ' Unable to reach the server. Please check your network connection and try again.',
        magicLink: 'Magic Link Login',
        magicLinkSubtitle: 'Complete your authentication from Minecraft',
        magicLinkVerifying: 'Verifying your magic link...',
        magicLinkValid: 'Magic link verified!',
        magicLinkExpired: 'This magic link has expired. Please run /panel again in Minecraft.',
        magicLinkInvalid: 'This magic link is invalid. Please run /panel again in Minecraft to get a new link.',
        magicLinkError: 'Failed to verify magic link. Please try again.',
        magicLinkPlayerName: 'Minecraft Player',
        magicLinkServerName: 'Server',
        magicLinkType: 'Action',
        magicLinkTypeLogin: 'Login to existing account',
        magicLinkTypeRegister: 'Create new account',
        magicLinkSetPassword: 'Set a password for your web panel account',
        magicLinkPasswordHint: 'You can use this password to log in directly next time',
        magicLinkComplete: 'Complete Authentication',
        magicLinkCompleting: 'Completing authentication...',
        magicLinkSuccess: 'Authentication successful! Redirecting...',
        magicLinkFailure: 'Authentication failed:',
        magicLinkOwnerWelcome: 'Welcome, Server Owner!',
        magicLinkPlayerWelcome: 'Welcome!',
        magicLinkNoCode: 'No magic link code provided. Please run /panel in Minecraft to get a link.',
        magicLinkUsed: 'This link has already been used. Please run /panel again in Minecraft to get a new link.',
        magicLinkBurned: 'This link was locked after too many wrong passwords. Please run /panel again in Minecraft to get a new link.',
        magicLinkRateLimited: 'Too many attempts. Please wait a few minutes and try again.',
        magicLinkSignedInAs: 'Signed in as',
        magicLinkStateBound: 'This Minecraft player is linked to the account {0}. Enter that account\'s password to sign in.',
        magicLinkTrustDevice: 'Remember this device (30 days)',
        magicLinkLogin: 'Sign in',
        magicLinkWrongPassword: 'Wrong password. Please try again.',
        magicLinkDeviceLogin: 'Sign in with this remembered device',
        magicLinkDeviceHint: 'This browser remembers a sign-in. Use it only if you ran /panel yourself as {0} on {1}.',
        magicLinkDeviceForgotten: 'This device is no longer remembered. Please enter your password.',
        magicLinkStateChanged: 'Something changed since this page was opened. The link has been checked again.',
        magicLinkLegacyLogin: 'Enter your UltiKits account password to sign in.',
        magicLinkStateUnbound: 'The Minecraft player {0} on server {1} is not linked to an UltiKits account yet. Create a new account, or log in to an account you already have and link it there.',
        magicLinkCreateAccount: 'Create new account',
        magicLinkLoginExisting: 'Log in to an existing account',
        magicLinkRegister: 'Create account and link',
        magicLinkStateConfirmLink: 'Link the Minecraft player {0} on server {1} to your account {2}?',
        magicLinkStateConfirmReplace: 'Your account {2} is already linked to the Minecraft player {3} on server {1}. Confirming replaces {3} with {0}; {3} will no longer be linked to your account.',
        magicLinkConfirm: 'Confirm and link',
        magicLinkStateBoundToViewer: 'This Minecraft player is linked to your account. Signing you in...',
        magicLinkRetry: 'Try again',
        magicLinkStateBoundToOther: 'The Minecraft player {0} on server {1} is linked to another account ({2}), not to your account {3}.',
        magicLinkStateViewerHasIdentity: 'Your account is linked to the Minecraft player {0} on this server.',
        magicLinkMoveHint: 'To move this identity to your current account: log in to the other account, unbind it in Settings, then run /panel again in game.',
        magicLinkSwitchAccount: 'Switch to account {0}',
        magicLinkCancel: 'Cancel',
        magicLinkCancelled: 'Cancelled. Nothing was linked. This link has not been used and stays valid until it expires.',
        magicLinkReopen: 'Reopen the link',
        magicLinkRefusalGameLogin: 'Before this link can link a new account, log in in game with /login once, then run /panel again.',
        magicLinkRefusalNotPermitted: 'This server could not prove that the request came from it, so this link can only sign in to an account this Minecraft player is already linked to. Ask the server owner to update UltiLogin and sign the server in to UltiCloud, then run /panel again.',
        serverLoginTitle: 'Server Authentication',
        serverLoginSubtitle: 'Link your UltiCloud account to your Minecraft server',
        serverLoginVerifying: 'Verifying login request...',
        serverLoginExpired: 'This login request has expired. Please run /ulticloud login again on your server.',
        serverLoginError: 'Failed to verify login request. Please try again.',
        serverLoginNoId: 'No login request ID provided. Please run /ulticloud login on your Minecraft server.',
        serverLoginServerName: 'Server Name',
        serverLoginModeLogin: 'Login',
        serverLoginModeRegister: 'Register',
        serverLoginUseCurrentSession: 'Use current session',
        serverLoginCurrentUser: 'Logged in as',
        serverLoginUseDifferentAccount: 'Use a different account',
        serverLoginLinkBtn: 'Link Server',
        serverLoginLoginBtn: 'Login & Connect Server',
        serverLoginRegisterBtn: 'Register & Connect Server',
        serverLoginSuccess: 'Authentication successful!',
        serverLoginSuccessTitle: 'Server Connected!',
        serverLoginSuccessMsg: 'Your server has been linked to your UltiCloud account. You can close this page — the server will pick up the connection automatically.',
        serverLoginFailure: 'Authentication failed:',
      },
      appBar: {
        server: 'Servers',
        member: 'Member',
        module: 'Modules',
        dev: 'Developer',
        profile: 'My profile',
        logout: 'Logout',
        logoutMsg: 'You have been logged out',
      },
    },
    badge: 'Badge',
    open: 'Open',
    close: 'Close',
    dataIterator: {
      noResultsText: 'No matching results',
      loadingText: 'Loading...',
    },
    dataTable: {
      itemsPerPageText: 'Items per page:',
      ariaLabel: {
        sortDescending: ': Sorted descending.',
        sortAscending: ': Sorted ascending.',
        sortNone: ': Not sorted.',
        activateNone: 'Click to remove sorting.',
        activateDescending: 'Click to sort descending.',
        activateAscending: 'Click to sort ascending.',
      },
      sortBy: 'Sort by',
    },
    dataFooter: {
      itemsPerPageText: 'Items per page:',
      itemsPerPageAll: 'All',
      nextPage: 'Next page',
      prevPage: 'Previous page',
      firstPage: 'First page',
      lastPage: 'Last page',
      pageText: '{0}-{1} of {2}',
    },
    dateRangeInput: { divider: 'to' },
    datePicker: {
      ok: 'OK',
      cancel: 'Cancel',
      range: { title: 'Select date', header: 'Enter date' },
      title: 'Select date',
      header: 'Enter date',
      input: { placeholder: 'Enter date' },
    },
    noDataText: 'No data',
    carousel: {
      prev: 'Previous',
      next: 'Next',
      ariaLabel: { delimiter: 'Carousel {0} of {1}' },
    },
    calendar: { moreEvents: '{0} more' },
    input: {
      clear: 'Clear {0}',
      prependAction: '{0} prepend action',
      appendAction: '{0} append action',
      otp: 'Please enter OTP character {0}',
    },
    fileInput: {
      counter: '{0} files',
      counterSize: '{0} files ({1} in total)',
    },
    timePicker: { am: 'AM', pm: 'PM' },
    pagination: {
      ariaLabel: {
        root: 'Pagination navigation',
        next: 'Next page',
        previous: 'Previous page',
        page: 'Go to page {0}',
        currentPage: 'Current page {0}',
        first: 'First page',
        last: 'Last page',
      },
    },
    stepper: { next: 'Next step', prev: 'Previous step' },
    rating: { ariaLabel: { item: 'Rating {0} of {1}' } },
    loading: 'Loading...',
    infiniteScroll: { loadMore: 'Load more', empty: 'No more' },
  },
}
